import React from 'react'
import { TextInput } from 'SRC/ui/FormElements'
import useTranslation from 'next-translate/useTranslation'

export const Email = () => {
  const { t } = useTranslation('common')

  const emailField = {
    id: 'email',
    name: 'email',
    label: t('Email')
  }

  return (
    <div className='form-email'>
      <TextInput {...emailField} />
    </div>
  )
}
